import { last } from '../../../utils/helper/lodash_replacements';
export class MultiSelectProgress {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get currentTask() {
        return this.question.tasks.find(task => !task.taskEval.isComplete) || last(this.question.tasks);
    }
    get isComplete() {
        return !this.currentTask;
    }
}
